// extracted by mini-css-extract-plugin
export var dateLabel = "_43-0";
export var dateLabelError = "_43-1";
export var fullWidth = "_43-2";
export var smaller = "_43-3";